import { Component, OnInit, Input, ViewChild, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectionStrategy} from '@angular/core';
import { Questions } from 'src/app/common-class/questions';
import { Answers } from 'src/app/common-class/answers';

declare var $: any;

import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { SelectedOptionList } from 'src/app/common-class/questions';
import { SurveyMessages } from 'src/app/common-class/survey-messages';
import { PreviewData } from 'src/app/common-class/survey';

@Component({
  selector: 'app-numeric-allocation',
  templateUrl: './numeric-allocation.component.html',
  styleUrls: ['./numeric-allocation.component.css'],
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class NumericAllocationComponent implements OnInit, OnChanges {

  @Input() JsonData: string;
  @Input() isMandatoryUpfront: boolean;
  @Input() isDisplayQno: boolean;
  @Input() isMobile: boolean;
  @Input() isNewParticipationButton: boolean;
  @Input() isResponseUpdate: boolean;
  @Output() ChangeAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();

  questions: Questions;
  questionsQDL: Questions;
  answerImagesLength: number;

  selectedQDLValue: number;

  columnWidth: any;
  selectedValueList: SelectedOptionList[] = [];

  public tempArray = [];
  public answersArray: any;
  range: boolean;

  intSum: number = 0;
  ngCount: number = 0;
  objTotal: any;

  isFormSubmit: boolean = false;
  isFormSubmitSub: any;
  isResetPage: boolean = false;
  isPreview: boolean;
  isNgOnChange: boolean;
  isAriaRequired: boolean = false;
  surveyMessages: SurveyMessages;
  surveyFormat: number;
  isNewParticipation: boolean;
  newParticipationBtnText: string;
  showNewParticipationButton: boolean;
  TotalText: string;
  isDisplayedPipeMessage: boolean;
  isAnsChange: boolean = false;

  ngOnChanges(changes: SimpleChanges) {

    let change = changes['JsonData'];

    if (change != undefined) {

      let curVal = JSON.stringify(change.currentValue);
      let preVal = JSON.stringify(change.previousValue);
      let ques = JSON.parse(this.JsonData);            
      if (curVal != preVal && preVal != undefined && (this.isResponseUpdate || this.isResetPage || ques.IsADLRuleApplied)) {
        this.questions = ques;
        this.answerPipingMessageDisplayed();
        if ((this.questions.DispAnsCol > 1 || this.questions.qtype == 'HR') && this.questions.Answers != null) {
          this.HorizontalAndVerticalHandling();
        }
        this.isNgOnChange = true;
        this.ngCount = 0;
        this.isResetPage = false;
      }
    }
  }

  constructor(private service: ParticipationDataService, private previewData: PreviewData) {
  }

  ngOnInit() {
    if (this.questions == null) {
      this.surveyMessages = this.service.surveyMessages;      
      this.questions = JSON.parse(this.JsonData);
      this.answerPipingMessageDisplayed();
      
      let updateItem = this.questions.Answers.find(
        e => e.hasImage && e.AnswerImages.length == 2);

      if (updateItem != null && updateItem != undefined) {
        this.answerImagesLength = 2;

        if (this.questions.population_type == 3) {
          if (this.questions.selectAnsValue != updateItem.value_id) {
            this.answerImagesLength = 0;
          }
        }

      } else {
        updateItem = this.questions.Answers.find(
          e => e.hasImage && e.AnswerImages.length == 1);

        if (updateItem != null && updateItem != undefined) {
          this.answerImagesLength = 1;

          if (this.questions.population_type == 3) {
            if (this.questions.selectAnsValue != updateItem.value_id) {
              this.answerImagesLength = 0;
            }
          }
        }
      }

      if (this.questions.answer_style == 1 && this.questions.RotateIndex == 0 && this.questions.Answers != null) {
        this.RandomAnswerHandling();
      }


      if ((this.questions.DispAnsCol > 1 || this.questions.qtype == 'HR') && this.questions.Answers != null) {
        this.HorizontalAndVerticalHandling();
      }

      for (let i = 0; i < this.questions.Answers.length; i++) {
        let ans = this.questions.Answers[i];
        this.selectedValueList.push({ value_id: ans.value_id, value_text: ans.ControlAns, isOther: ans.isOther });
      }


      // if (this.questions.selectAnsValue > 0) {
      //   let updateItem = this.questions.Answers.find(
      //     e => e.value_id == this.questions.selectAnsValue);

      //   if (updateItem != null && updateItem != undefined) {

      //     if (updateItem.Rule_id > 0) {
      //       this.InlineQDLHandling(updateItem.Rule_id);
      //     }
      //   }
      // }

      if (this.questions.selectedOptionList != null) {
        this.selectedValueList = this.questions.selectedOptionList;
      }

      if (this.questions.constraintType > 0 &&
        (this.questions.selectedOptionList != null ||
          this.questions.selectedOptionList != undefined)) {
        this.Calculations();
      }
    }
    // Subscibe To Form Submit/Next Event ( Event is fired when mandatory is not satisfied )
    this.isFormSubmitSub = this.service.emitFormSubmitEvent.subscribe((data) => {
      this.isFormSubmit = data;
    });

    this.service.emitResetPageEvent.subscribe((data) => {
      this.isResetPage = data;
      this.isAnsChange = false;
    });


    this.isPreview = this.service.GroupType.toUpperCase() == 'PREVIEW';

    this.surveyFormat = this.service.surveyFormat;
    this.isNewParticipation = this.service.isNewParticipation;
    this.newParticipationBtnText = this.service.newParticipationBtnText;
    this.showNewParticipationButton = this.isNewParticipationButton;
    this.TotalText = this.service.getSurveyMessages().Total;
  }

  ngAfterViewInit() {
    if(window.navigator.userAgent.indexOf("Chrome") != -1) {
      $('.answerParent').css('width', 'calc(100% + 1px)');
      // $('.question-option-wrapper').css('width', 'calc(100% + 1px)');
    }

    var self = this;

    let elemid = '#dv_' + self.questions.UniqueNumber;

    $('.ic-image-holder').height($('.ic-image-holder').outerWidth());

    $(window).on('resize', function () {
      $('.ic-image-holder').height($('.ic-image-holder').outerWidth());
    });

    if(self.questions.DispAnsCol > 1)
    {
        setTimeout(() => {
          let elemid = '#dv_' + self.questions.UniqueNumber;
          if ($(elemid).find('.answer-option-wrapper').outerWidth() > $(elemid).outerWidth()) {
            $(elemid).find('.div-scroll-btn').show();
          }
        }, 0);
        $(document).ready(function () {
        let elemid = '#dv_' + self.questions.UniqueNumber;
        $('.fieldset-wrapper-scroll').scroll(function () {
          if($('.RTLDir').length > 0) {
            if ($(this).scrollLeft() == 0) {
              $(this).parents('.divScroll').find('.div-scroll-btn').hide();
            } else {
              $(elemid).parents('.divScroll').find('.div-scroll-btn').show();
            }
          } else {
            if ($(this).find('.answer-option-wrapper').outerWidth() - $(this).scrollLeft() <= $(this).outerWidth() + 5) {
              $(this).parents('.divScroll').find('.div-scroll-btn').hide();
            } else {
              $(this).parents('.divScroll').find('.div-scroll-btn').show();
            }
          }
        });
      });
    }

    this.calculateContentWidth(elemid);

    this.isAriaRequired = (this.questions.mandatory && this.isMandatoryUpfront) || (this.questions.mandatory && this.isFormSubmit && this.questions.isMandatoryInvalid);

  }

  ngOnDestroy() {
    this.isFormSubmitSub.unsubscribe();
  }

  answerPipingMessageDisplayed(){
    if (this.previewData != undefined && this.service.getPrevPgChnge() && //this.previewData.isPrevPgChnge &&
      this.questions.AnsPipeCondition != 0 && this.questions.AnsPipeCondition != 1 &&
      this.questions.AnsPipeCondition != 3 && this.questions.AnsPipeCondition != 4) {
      this.isDisplayedPipeMessage = true;
    } else {
      this.isDisplayedPipeMessage = false;
    }
  }

  RandomAnswerHandling() {
    let currentIndex = this.questions.Answers.length, temporaryValue, randomIndex;
    let updateItem = this.questions.Answers.find(e => e.isOther);

    if (updateItem != undefined && updateItem != null) {
      currentIndex -= 1;
    }

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = this.questions.Answers[currentIndex];
      this.questions.Answers[currentIndex] = this.questions.Answers[randomIndex];
      this.questions.Answers[randomIndex] = temporaryValue;
    }
  }
  HorizontalAndVerticalHandling() {
    
    let DispAnsCol = this.questions.DispAnsCol;

    let qShowAnswers = this.questions.Answers.filter(e=>e.isADLHide == false)

    let answerLength = qShowAnswers.length;

    let updateItem = qShowAnswers.find(e => e.isOther);

    if (updateItem != undefined && updateItem != null) {
      answerLength -= 1;
    }
    let rowCount = Math.ceil(answerLength / DispAnsCol);

    this.columnWidth = (100 / DispAnsCol);

    if (this.questions.DispAnsFormat == 1) {  //Vertical
      let ansArray = [];
      for (let i = 0; i < rowCount; i++) {
        let tempArray = [];
        for (let j = i; j < answerLength; j = j + rowCount) {
          tempArray.push(qShowAnswers[j]);
        }

        ansArray.push(tempArray);
      }
      if (updateItem != undefined && updateItem != null) {
        let tempArray = [];
        tempArray.push(updateItem);
        ansArray.push(tempArray);
      }
      this.tempArray[0] = ansArray;

    } else if (this.questions.DispAnsFormat == 2) { //Horizontal
      let ansArray = [];

      for (let i = 0; i < rowCount; i++) {
        let tempArray = [];
        let counter = 0;
        for (let j = (i * DispAnsCol); j < answerLength; j++) {
          counter++;
          tempArray.push(qShowAnswers[j]);
          if (counter == DispAnsCol) {
            break;
          }
        }

        ansArray.push(tempArray);
      }
      if (updateItem != undefined && updateItem != null) {
        let tempArray = [];
        tempArray.push(updateItem);
        ansArray.push(tempArray);
      }

      this.tempArray[0] = ansArray;
    }

    this.answersArray = this.tempArray;
  }

  GetMandatoryState(): boolean {
    if (this.questions != null) {
      return this.questions.mandatory;
    }
  }

  // InlineQDLHandling(rule_Id: number) {
  //   if (this.questions.rules.length > 0) {
  //     let updateItem = this.questions.rules.find(e => e.Rule_id == rule_Id);
  //     if (updateItem != undefined && updateItem != null) {
  //       this.questionsQDL = this.service.GetQDL(updateItem.ConditionQID);

  //       let answer = this.questions.Answers.find(e => e.CQ_QID == updateItem.ConditionQID);

  //       if (answer != undefined && answer != null) {
  //         this.selectedQDLValue = answer.value_id;
  //       } else {
  //         this.selectedQDLValue = 0;
  //       }
  //     }
  //   }
  // }



  findIndexToUpdate(answer) {
    return answer === this;
  }

  GetQuestionsString(question: Questions, index: number): string {
    return JSON.stringify(question);
  }

  UpdateQuestionsData(question: Questions) {
    this.ChangeAnswersData.emit(question);
    if(question.AnswerText!=null){
      this.isAnsChange = true;
    }
  }

  checkInput(event) {

    if (event.target.checked) {
      let val = event.target.value;
    }
    if ($(event.target).find('input').prop('checked') == false) {
      $(event.target).find('input').prop('checked', true);
    } else {
      $(event.target).find('input').prop('checked', false);
    }
  }

  //added validation with numeric allocation
  NumberValidation(event: any, curVal: any, answer: Answers) {
    this.range = false;
    if (curVal != "") {
      if (isNaN(curVal) || curVal.indexOf(" ") != -1 || curVal.indexOf("E") != -1 || curVal.indexOf("e") != -1) {
        this.questions.isValid = true;
        this.range = true;
        answer.isValid = true;
      } else {
        this.questions.isValid = false;
        answer.isValid = false;
      }
    }
    else {
      answer.isValid = false;
      this.questions.isValid = false;
    }

    let updatedAns = this.questions.Answers.find(e => e.ms_id == answer.ms_id);

    if (updatedAns != null && updatedAns != undefined) {
      let index = this.questions.Answers.indexOf(updatedAns);

      this.questions.Answers[index] = updatedAns;
    }

    if (!this.questions.isValid && this.questions.constraintType > 0) {
      this.Calculations();
    }

    this.AddSelectedValueList(answer);
    this.questions.selectedOptionList = this.selectedValueList;

    if (this.selectedValueList.length > 0 && this.selectedValueList.filter(e => (e.value_text != null && e.value_text != "")).length > 0) {
      this.questions.AnswerText = "Option Filled";
      this.questions.pageto = answer.pageto;
    } else {
      this.questions.AnswerText = null;
      this.questions.pageto = null;
    }

    let ansValid = this.questions.Answers.filter(e => e.isValid);

    if (ansValid != null && ansValid.length > 0) {
      this.questions.isValid = true;
    }
    this.service.setQuestionChange(this.questions);
    this.ChangeAnswersData.emit(this.questions);
    if(this.questions.AnswerText!=null){
      this.isAnsChange = true;
    }
  }

  Calculations() {
    let cal: number = 0;
    let nullCount: number = 0;
    let isCalculate: boolean = false;
    for (let i = 0; i < this.questions.Answers.length; i++) {
      // PRT 102967 -ve calculation doesn't work for NA
      if (this.questions.Answers[i].ControlAns && !(isNaN(this.questions.Answers[i].ControlAns) || this.questions.Answers[i].ControlAns.indexOf(" ") > -1)) { // Check for undefinded OR Null object
        cal += parseFloat(this.questions.Answers[i].ControlAns);
      
        isCalculate = true;
      }
      else {
        nullCount++;
      }
    }

    // PRT 102967 zero is not calculated
    if (this.questions.Answers.length == nullCount) { // If all values are null then show empty total box
      this.questions.otherAnswer = null;
    }
    else {
      if((cal % 1) != 0)
        {
          this.questions.otherAnswer = cal.toFixed(2).toString(); // Else show calculation of numbers present in the textbox 

        }
        else
        {
          this.questions.otherAnswer = cal.toString(); // Else show calculation of numbers present in the textbox 
        } 
      
    }

    if (this.questions.constraintNum > 0 && cal != parseInt(this.questions.num_range_1) && isCalculate) {
      this.questions.isValid = true;
      this.questions.isAlertDanger = true;
    } else {
      this.questions.isAlertDanger = false;
    }
  }

  AddSelectedValueList(answer: Answers) {
    let selectedList = this.selectedValueList.find(e => e.value_id == answer.value_id);

    if (this.selectedValueList.indexOf(selectedList) < 0) {
      this.selectedValueList.push({ value_id: answer.value_id, value_text: answer.ControlAns, isOther: answer.isOther });
    }
    else {
      this.RemoveSelectedList(answer);

      this.AddSelectedValueList(answer);
    }
  }

  RemoveSelectedList(answer: Answers) {
    let selectedList = this.selectedValueList.find(e => e.value_id == answer.value_id);

    let curIndex = this.selectedValueList.indexOf(selectedList);

    if (curIndex >= 0) {
      this.selectedValueList.splice(curIndex, 1);
    }
  }

  getAnsImageMediaCSS(answer: Answers) {
    if ((answer.hasImage == true && answer.AnswerImages.length == 1 && answer.hasMedia == false) ||
      (answer.hasMedia == true && answer.AnswerMedias.length == 1 && answer.hasImage == false)) {
      return 'single-ans-image';
    }
    else if ((answer.hasImage == true && answer.AnswerImages.length == 1) &&
      (answer.hasMedia == true && answer.AnswerMedias.length == 1)) {
      return 'multi-ans-image';
    }
    else if ((answer.hasImage == true && answer.AnswerImages.length == 2) ||
      (answer.hasMedia == true && answer.AnswerMedias.length == 2)) {
      return 'multi-ans-image';
    }
  }

  calculateContentWidth(ele) {
    var widthArr = [];

    if ($(ele).find('.twoColumns').length || $(ele).find('.threeColumns').length || $(ele).find('.fourColumns').length || $(ele).find('.fiveColumns').length) {
      /*Multiple columns width calculations*/

      // $(ele).find('.answer-option-wrapper label.a-strip-na.na-tb-space').each(function (i) {
      //   widthArr[i] = $(this).outerWidth(true);
      // });

      // var maxWidth = Math.max(...widthArr);

      // if (maxWidth > 450) {
      //   maxWidth = 450;
      // }

      // $(ele).find('.answer-option-wrapper label.a-strip-na.na-tb-space').each(function (i) {
      //   $(this).css({ 'min-width': maxWidth, 'max-width': maxWidth, 'display': 'inline-block', 'vertical-align': 'middle' });
      // });

      var i = 0, j = 0, totallen = 0;
      var rowLen = $(ele).find('table.main-hrb-cont > tr').length;
      var colLen = $(ele).find('table.main-hrb-cont > tr:first-child .a-strip-na').length;
      var lengthArr = [];
      if (colLen == 2) {
        lengthArr = [0, 0];
      } else if (colLen == 3) {
        lengthArr = [0, 0, 0];
      } else if (colLen == 4) {
        lengthArr = [0, 0, 0, 0];
      } else {
        lengthArr = [0, 0, 0, 0, 0];
      }

      $(ele).find('td.answer-option label.a-strip-na').css('padding', '12px 0 12px 4px');
      //$(ele).find('.na-total').closest('label.a-strip-na').css('padding', '12px 0 12px 0px');

      $(ele).find('td.answer-option label.a-strip-na .answer-text').css({ 'white-space': 'nowrap' });

      for (i = 0; i < colLen; i++) {
        if($(ele).find('.na-total1').outerWidth()){
          lengthArr[i] = $(ele).find('.na-total1').outerWidth()+20;
        }
        for (j = 0; j < rowLen; j++) {
          if ($(ele).find('table.main-hrb-cont > tr').eq(j).find('td.answer-option').eq(i).find('.answer-text').outerWidth() == undefined) {
            //lengthArr.push(0);
          } else {
            if (lengthArr[i] < ($(ele).find('table.main-hrb-cont > tr').eq(j).find('td.answer-option').eq(i).find('.answer-text').outerWidth())) {
              lengthArr[i] = $(ele).find('table.main-hrb-cont > tr').eq(j).find('td.answer-option').eq(i).find('.answer-text').outerWidth();
            }
          }
        }
        if (lengthArr[i] > 360) {
          lengthArr[i] = 360;
        }
      }

      for (i = 0; i < lengthArr.length; i++) {
        totallen = totallen + lengthArr[i];
      }

      for (i = 0; i < colLen; i++) {
        for (j = 0; j < rowLen; j++) {
          if(i==0 && j==0) {
            $(ele).find('.na-total').css({'width': lengthArr[i] + 'px', 'min-width': lengthArr[i] + 'px'});
          }
          $(ele).find('table.main-hrb-cont > tr').eq(j).find('td.answer-option').eq(i).find('.answer-text').css({ 'min-width': lengthArr[i], 'max-width': lengthArr[i], 'display': 'inline-block', 'vertical-align': 'middle', 'word-break': 'normal' });
        }
      }

      $(ele).find('table.main-hrb-cont').css('width', totallen + 'px');

      $(ele).find('td.answer-option label.a-strip-na .answer-text').css('white-space', 'normal');


    } else {
      $(ele).find('.answer-option-wrapper .a-strip-na.na-tb-space label').each(function (i) {
        widthArr[i] = $(this).outerWidth(true);
      });

      var maxWidth = Math.max(...widthArr);

      if (maxWidth > 360) {
        maxWidth = 360;
      }
      if(maxWidth!=0){
        $(ele).find('.answer-option-wrapper .a-strip-na.na-tb-space label').each(function (i) {
          $(this).css({ 'min-width': maxWidth, 'max-width': maxWidth, 'display': 'inline-block', 'vertical-align': 'middle' });
        });
      }
    }
  }

  ngAfterContentHandle() {
    if (this.ngCount == 0) {
      this.ngAfterViewInit();
      this.ngCount++;
    }
  }

  keyDown(event: any) {
    let keyCode = event.which;
    if (keyCode >= 65 && keyCode <= 90) {
      return false;
    }else{
      this.isAnsChange = true;
    }
  }

  gotoNextQuestion(question: Questions, event: any) {
    this.service.gotoNextQuestion(question, event);
  }

  gotoNextQuestionKeyboard(question,event) {
    event.preventDefault();
    this.gotoNextQuestion(question,event.target);
  }

  getAnswerPipeMessage(): string{
    return this.service.getAnswerPipeMessage();
  }

  getAnswerInvalid(answers: Answers[]): boolean {
    let elemid = this.questions.UniqueNumber + '_na_table';
    for (let i = 0; i < answers.length; i++) {
      if (answers[i].isValid) {
          $('#'+elemid).addClass('a-strip-bottom-table');
        return true;
      }
    }

    $('#'+elemid).removeClass('a-strip-bottom-table');
    return false;
  }
}
